import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!dsn) {
    console.warn('Sentry DSN not configured. Error monitoring is disabled.')
    return
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      // 'log' fora da lista: o chat emite dezenas de console.log por evento de realtime,
      // e cada um virava um evento serializado e enviado. Aviso e erro continuam indo —
      // é deles que se precisa para investigar.
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
    _experiments: {
      enableLogs: true,
    },
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Session Replay grava a árvore inteira via MutationObserver, e com maskAllText:false
    // serializa o texto real de cada nó. Numa tela que repinta a cada mensagem, gravar 10%
    // das sessões saía caro para quem estava usando. Em 0, só erro dispara replay
    // (replaysOnErrorSampleRate abaixo) — que é quando ele realmente serve.
    // Para voltar a amostrar sessões inteiras, subir este valor.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (import.meta.env.DEV) {
        console.log('[Sentry] Event captured:', event)
      }
      return event
    },
  })
}

export function setUserContext(user: {
  id: string
  email: string
  name?: string
  accountId?: string
  profile?: string
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
    accountId: user.accountId,
    profile: user.profile,
  } as Sentry.User & { accountId?: string; profile?: string })
}

export function clearUserContext() {
  Sentry.setUser(null)
}

export function captureError(error: Error, context?: Record<string, unknown>) {
  Sentry.captureException(error, { extra: context })
}

export function captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
  Sentry.captureMessage(message, level)
}

export { Sentry }
